import {CHANGE} from '@megaphonenpm/mputils/src/constants.js';
import {SCENE_TYPE_PREDICTION} from './constants.js';
import {GetRankingsTask} from './GetRankingsTask.js';
import {areJSONEqual} from '@megaphonenpm/mputils/src/utils.js';

/**
 * Retrieves the specified rankings compares them to the local version.
 * If the two rankings records are different, then UpdateRankingsTask dispatches a CHANGE event.
 */
export class UpdateRankingsTask extends GetRankingsTask {
  constructor (sourceID, dataStore, sceneType = SCENE_TYPE_PREDICTION) {
    super(sourceID, dataStore, sceneType);
    this.name = 'UPDATE_RANKINGS_TASK';
    this.dataStore = dataStore;
  }

  /**
   * If the loaded rankings differ from the rakings currently in the dataStore, then
   * dispatch a CHANGE event.
   *
   * @param loadedRankings The rankings loaded from the external service.
   */
  onRankingsLoadSuccess (loadedRankings) {
    let currentRankings = this.dataStore.rankings.get(this.sourceID);


    if (!areJSONEqual(loadedRankings, currentRankings)) {
      this.dataStore.rankings.set(this.sourceID, loadedRankings);

      this.dispatchEvent(CHANGE, {
        currentRankings: currentRankings,
        newRankings: loadedRankings
      });
    }
  }
}
